export default {
    test: "test  11",
    lng: `简体中文`,
};
